import React from 'react';
import { Routes, Route } from 'react-router';
import Start from '../start/Start';
import Contacts from '../contacts/Contacts';
import Reports from '../reports/Reports';
import NewReports from '../reports/NewReports';
import Account from '../account/Account';
import Editor from '../editor/Editor';
import Automations from '../automations/Automations';
import SuperAdmin from '../superAdmin/SuperAdmin';

const Workarea = () => {
  return (
    <Routes>
      <Route path="reports/*" element={<Reports />} />
      <Route path="newreports/*" element={<NewReports />} />
      <Route path="account/*" element={<Account />} />
      <Route path="editor/*" element={<Editor />} />
      <Route path="contacts/*" element={<Contacts />} />
      <Route path="automations/*" element={<Automations />} />
      <Route path="superadmin/*" element={<SuperAdmin />} />
      <Route path="/" element={<Start />} />
    </Routes>
  );
};

export default Workarea;